(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["sugarlab-atelier"] && !Shopify.designMode) return;
  try {
    
document.addEventListener('click',(event)=>{
 const button=event.target.closest('.sl-play');
 if(!button)return;
 const video=button.closest('.sl-player').querySelector('video');
 if(!video)return;
 video.play().then(()=>{button.hidden=true}).catch(()=>{button.hidden=false});
 video.addEventListener('ended',()=>{button.hidden=false},{once:true});
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["sugarlab-catalog"] && !Shopify.designMode) return;
  try {
    
(() => {
  const init = () => {
    const root = document.querySelector('[data-catalog-section="full"]');
    if (!root || root.dataset.ready) return;
    root.dataset.ready = 'true';
    const cards = [...document.querySelectorAll('[data-cake-card]')];
    const search = root.querySelector('[data-catalog-search]');
    const filters = [...root.querySelectorAll('[data-catalog-filter]')];
    const more = document.querySelector('[data-catalog-more]');
    const empty = document.querySelector('[data-catalog-empty]');
    const count = root.querySelector('[data-catalog-count]');
    const dialog = root.querySelector('[data-catalog-dialog]');
    let category = 'all', limit = 24, opener;
    const normalize = value => value.toLowerCase().normalize('NFD').replace(/[\u0300-\u036f]/g, '');
    const update = () => {
      const terms = normalize(search.value.trim()).split(/\s+/).filter(Boolean);
      let total = 0;
      cards.forEach(card => {
        const text = normalize(card.dataset.name + ' ' + card.dataset.code);
        const match = (category === 'all' || card.dataset.tags.split(',').includes(category)) && terms.every(term => text.includes(term));
        card.hidden = !match || total >= limit;
        if (match) total++;
      });
      count.textContent = total;
      if (more) more.hidden = total <= limit;
      if (empty) empty.hidden = total !== 0;
    };
    const open = card => {
      opener = card.querySelector('[data-catalog-open]');
      const img = card.querySelector('img').cloneNode();
      img.removeAttribute('loading'); img.removeAttribute('sizes'); img.removeAttribute('srcset');
      const url = new URL(img.src); url.searchParams.set('width', '1600'); img.src = url.href;
      dialog.querySelector('.sl-catalog__large').replaceChildren(img);
      dialog.querySelector('#sl-catalog-dialog-title').textContent = card.dataset.name;
      dialog.querySelector('[data-catalog-dialog-code]').textContent = card.dataset.code;
      dialog.querySelector('[data-catalog-dialog-quote]').href = card.querySelector('[data-catalog-quote]').href;
      if (!dialog.open) dialog.showModal();
    };
    const close = () => { dialog.close(); if (opener && !opener.closest('[hidden]')) opener.focus(); };
    filters.forEach(button => button.addEventListener('click', () => { category = button.dataset.catalogFilter; limit = 24; filters.forEach(item => item.setAttribute('aria-pressed', String(item === button))); update(); }));
    search.addEventListener('input', () => { limit = 24; update(); });
    if (more) more.addEventListener('click', () => { limit += 24; update(); });
    cards.forEach(card => card.querySelector('[data-catalog-open]').addEventListener('click', () => open(card)));
    dialog.querySelector('[data-catalog-close]').addEventListener('click', close);
    dialog.addEventListener('click', event => { if (event.target === dialog) { const box = dialog.getBoundingClientRect(); if (event.clientX < box.left || event.clientX > box.right || event.clientY < box.top || event.clientY > box.bottom) close(); } });
    update();
    const linked = cards.find(card => '#' + card.dataset.code === location.hash);
    if (linked) { limit = cards.length; update(); open(linked); }
  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
  document.addEventListener('shopify:section:load', () => { const root = document.querySelector('[data-catalog-section="full"]'); if (root) delete root.dataset.ready; init(); });
})();

  } catch(e) { console.error(e); }
})();
})();
